<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">待就诊患者</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <div class="search">
                    <el-input  placeholder="请输入挂号编号" v-model="serialNumber" clearable style="margin:0 10px 0 0;width:300px">
                        <template slot="prepend">挂号编码</template>
                    </el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getPatient">搜索</el-button>
                </div>
                <el-card class="box-card" shadow='never'>
                    <div slot="header" class="clearfix">
                        <span>患者信息</span>
                    </div>
                    <div class="kong">
                        <span v-show="!patientName">暂无信息</span>
                    </div>
                    <el-row  v-show="patientName">
                        <el-col :span="12" class="item">
                            <el-input v-model="patientName" disabled>
                                <template slot="prepend">患者姓名</template>
                            </el-input>
                        </el-col>
                        <el-col :span="12" class="item">
                            <el-input v-model="price" disabled>
                                <template slot="prepend">挂号费用</template>
                            </el-input>
                        </el-col>
                        <el-col :span="12" class="item">
                            <el-input v-model="status" disabled>
                                <template slot="prepend">就诊状态</template>
                            </el-input>
                        </el-col>
                        <el-col :span="12" class="item">
                            <el-input v-model="visitType" disabled>
                                <template slot="prepend">就诊类型</template>
                            </el-input>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm">就诊</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Add",
        data() {
            return {

                loading: false,
                add_waresCode:'',
                pageSize:20,
                currentPage:1,
                tableData:[],
                waresList:[],
                status:'',
                visitType:"",
                price:"",
                serialNumber:"",
                patientName:"",
                registerCode:"",
                totalItems: 0,
                th:0,
                name:'',
                searchUrl:'',
                confirmUrl:'',
                visitTypeValue:[
                    {
                        val:-1,
                        name:'就诊类型'
                    },
                    {
                        val:1,
                        name:'初诊'
                    },
                    {
                        val:2,
                        name:'复诊'
                    },
                ],
                statusValue:[
                    {
                        val:-1,
                        name:'全部状态'
                    },{
                        val:1,
                        name:'已挂号'
                    },{
                        val:2,
                        name:'待诊中'
                    },{
                        val:3,
                        name:'诊疗中'
                    },{
                        val:4,
                        name:'已诊疗'
                    },{
                        val:11,
                        name:'作废'
                    }
                ],


            }
        },

        methods: {
            init(){
                this.searchUrl="CureFlow/SelectRecordToserialNumber"
                this.confirmUrl="CureFlow/Report"
                this.serialNumber=''
                this.patientName=''
                this.visitType=''
                this.status=''
            },
            closeSelf() {
                this.$emit("closeWaitingDoctor");
            },
            confirm(){
                if(!this.registerCode){
                    this.$message.error('请先查询患者')
                    return
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+this.confirmUrl,
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        registerCode:this.registerCode,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.closeSelf();
                        this.$emit('getList');
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            changeWares(selVal){
                this.add_waresCode=selVal;
            },
            statusTitle(row){
                for(var i in this.statusValue){
                    if(this.statusValue[i].val==row){
                        return this.statusValue[i].name
                    }
                }
            },
            visitTypeTitle(row){
                for(var i in this.visitTypeValue){
                    if(this.visitTypeValue[i].val==row){
                        return this.visitTypeValue[i].name
                    }
                }
            },
            getPatient(){
                if(!this.serialNumber){
                    this.$message.error('请输入挂号编码')
                    return
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+this.searchUrl,
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        serialNumber:this.serialNumber,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data= response.data.data;
                        this.visitType=this.visitTypeTitle(data.visitType);
                        this.status=this.statusTitle(data.status);
                        this.patientName=data.patient.name;
                        this.registerCode=data.registerCode;
                        this.price=data.price
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

<style  lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:700px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .search{
        display: flex;
        justify-content: center;
    }
    .box-card{
        margin: 20px;
    }
    .kong{
        display: flex;
        justify-content: center;
        color: #999;
    }
    .modal-body {
        position: relative;
        padding: 20px 20px;
        z-index: 99;
        height: 100%;
    }
    .modal-body /deep/  .el-input.is-disabled .el-input__inner {
        background-color: #fff;
        border-color: #E4E7ED;
        color: #000;
        cursor: not-allowed;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content:center;
        padding: 15px;
        display: flex;
        .el-button{
            width: 15%;
            font-size: 16px;
        }
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding:10px;
    }
    .label{
        padding: 5px 0px;
    }
</style>